import { useEffect } from 'react'

import {
  RECOMMENDATION_WIDGET_PDP_AVAILABLE,
  type RecommendationWidgetType,
} from '../../recommendation/config/RecommendationAreaType'
import { useExperimentsContext } from '../components/ExperimentsContext'
import { EXPERIMENT_NAME_PDP_AVAILABLE } from '../model/EXPERIMENT_NAME'

export const usePdpAvailableExperimentActivation = ({
  areaId,
  intersected,
}: {
  areaId: RecommendationWidgetType
  intersected: boolean
}): void => {
  const { addExperimentKeysForActivation } = useExperimentsContext()

  useEffect(() => {
    if (!intersected || areaId !== RECOMMENDATION_WIDGET_PDP_AVAILABLE) {
      return
    }

    addExperimentKeysForActivation(EXPERIMENT_NAME_PDP_AVAILABLE)
  }, [addExperimentKeysForActivation, areaId, intersected])
}
